import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home";
import Login from "./views/account/Login";
import Profile from "./views/account/Profile";
import TaskSingle from "./views/TaskSingle";
import CreateWorkspace from "./views/CreateWorkspace";
import Subscribe from "./views/Subscribe";
import Workspaces from './views/Workspaces';
import WorkspaceSingle from "./views/WorkspaceSingle";
import ConfirmEmail from './views/account/ConfirmEmail';
import ValidateEmail from './views/account/ValidateEmail';

Vue.use(Router);

let router = new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes: [
        {
            path: "/",
            name: "home",
            component: Home,
            redirect: "/workspace/",
            meta: { 
                requiresAuth: true
            }
        },
        {
            path: "/workspace/",
            name: "workspaces",
            component: Workspaces,
            meta: { 
                requiresAuth: true
            }
        },
        {
            path: "/workspace/create/",
            name: "workspace_create",
            component: CreateWorkspace,
            meta: { 
                requiresAuth: true
            }
        },
        {
            path: "/workspace/:workspace_id/",
            name: "workspace_single",
            component: WorkspaceSingle,
            meta: { 
                requiresAuth: true
            }
        },
        {
            path: "/workspace/:workspace_id/task/:task_id/",
            name: "task_single",
            component: TaskSingle,
            meta: { 
                requiresAuth: true
            }
        },
        {
            path: "/login/",
            name: "login",
            component: Login,
        },
        {
            path: "/confirm-email/",
            name: "confirmEmail",
            component: ConfirmEmail,
        },
        {
            path: "/validate-email/",
            name: "validateEmail",
            component: ValidateEmail,
        },
        {
            path: "/profile/",
            name: "profile",
            component: Profile,
            meta: { 
                requiresAuth: true
            }
        },
        {
            path: "/subscribe/",
            name: "subscribe",
            component: Subscribe,
            meta: { 
                requiresAuth: true
            }
        },
    ],
    scrollBehavior (to, from, savedPosition) {
        return { x: 0, y: 0 }
    }
});

router.beforeEach((to, from, next) => {
    if(to.matched.some(record => record.meta.requiresAuth)) {
        if (localStorage.getItem('jwt') == null) {
            next({
                path: '/login',
                params: { nextUrl: to.fullPath }
            })
        } else {
            document.body.className = to.name;
            next()
        }
    }else {
        document.body.className = to.name;
        next() 
    }
})



export default router;